import { useState } from 'react';
import ReturnCallButton from './ReturnCallButton';
import { SettingsOmnibusContextProvider } from '../contexts/SettingsOmnibusContext';
import { useWidgetDetails } from 'calling-cross-tab-library/external/useWidgetDetails';
import { getActiveCallDetails, getCallStatus, getCriticalFailureReason } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import CallStatusIcon from './CallStatusIcon';
import { getShouldShowActiveCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { getCallReviewPageUrl } from '../../utils/urls';
import { CriticalFailureReasons } from 'calling-cross-tab-library/constants/CriticalFailureReasons';
import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import { useConnectionStatus } from 'calling-cross-tab-library/external/useConnectionStatus';
import { ConnectionStatusTypes } from 'shared-worker-versioning/lib/types/ConnectionStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "ReturnCallButtonWrapper__Container",
  componentId: "iahfal-0"
})(["display:flex;width:100%;align-items:center;"]);
const ReturnCallButtonWrapper = ({
  callId,
  inboundCallDestinationPhoneNumber,
  inboundCallOriginPhoneNumber
}) => {
  const [callStarted, setCallStarted] = useState(false);
  const portalId = PortalIdParser.get();
  const {
    widgetDetails
  } = useWidgetDetails();
  const callStatus = getCallStatus(widgetDetails);
  const activeCallDetails = getActiveCallDetails(widgetDetails);
  const crmObjectId = activeCallDetails && activeCallDetails.crmObjectId;
  const criticalFailureReason = getCriticalFailureReason(widgetDetails) || CriticalFailureReasons.NONE;
  const connectionStatus = useConnectionStatus();
  const isError = criticalFailureReason !== CriticalFailureReasons.NONE || connectionStatus === ConnectionStatusTypes.FAILED;
  const isAnswered = callStatus === CallWidgetStates.ANSWERED;
  const message = isError ? 'call-highlight-card.returnCall.callStatus.failed' : isAnswered ? 'call-highlight-card.returnCall.callStatus.connected' : 'call-highlight-card.returnCall.callStatus.dialing';
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(SettingsOmnibusContextProvider, {
      children: /*#__PURE__*/_jsx(ReturnCallButton, {
        callId: callId,
        inboundCallDestinationPhoneNumber: inboundCallDestinationPhoneNumber,
        inboundCallOriginPhoneNumber: inboundCallOriginPhoneNumber,
        setCallStarted: setCallStarted
      })
    }), callStarted && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "p-left-4 p-right-2",
        children: [/*#__PURE__*/_jsx(CallStatusIcon, {
          callStatus: callStatus,
          isError: isError
        }), /*#__PURE__*/_jsx("span", {
          className: "p-left-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: message
          })
        })]
      }), crmObjectId && getShouldShowActiveCallState(callStatus) && /*#__PURE__*/_jsx(UILink, {
        href: getCallReviewPageUrl(portalId, crmObjectId),
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'call-highlight-card.returnCall.takeNotes'
        })
      })]
    })]
  });
};
export default ReturnCallButtonWrapper;